/**
 * Mode d'exécution du SDK.
 * - `browser` : navigateur classique — le SDK gère la création de session et le cookie.
 * - `kiosk`   : borne avec "Altazion Device Shell" — le browser embarqué gère les cookies.
 */
export type CommerceMode = 'browser' | 'kiosk'

export interface CommerceContextOptions {
  /** URL de base de l'API (ex. : "https://api.monsite.com") */
  baseUrl: string
  /** Identifiant ou URL du site web pour la création de session (mode browser) */
  siteUrl?: string
  /**
   * Clé primaire du site (alternative à siteUrl).
   * Requiert aussi rjsId.
   */
  sitePk?: number
  /** Identifiant du tenant RJS (nécessaire avec sitePk) */
  rjsId?: number
  /** Locale par défaut (ex. : "fr-FR") */
  locale?: string
  /** Devise par défaut (ex. : "EUR") */
  currency?: string
}

/**
 * Contexte partagé du SDK, instancié une seule fois et transmis
 * à tous les sous-systèmes (HttpAdapter, SessionManager, modules…).
 */
export class CommerceContext {
  readonly baseUrl: string
  readonly siteUrl: string | undefined
  readonly sitePk: number | undefined
  readonly rjsId: number | undefined
  readonly locale: string
  readonly currency: string
  readonly mode: CommerceMode

  constructor(options: CommerceContextOptions) {
    this.baseUrl = options.baseUrl.replace(/\/$/, '')
    this.siteUrl = options.siteUrl
    this.sitePk = options.sitePk
    this.rjsId = options.rjsId
    this.locale = options.locale ?? 'fr-FR'
    this.currency = options.currency ?? 'EUR'
    this.mode = CommerceContext.detectMode()
  }

  private static detectMode(): CommerceMode {
    if (typeof navigator !== 'undefined' && navigator.userAgent.includes('Altazion Device Shell')) {
      return 'kiosk'
    }
    return 'browser'
  }
}
